<template>
    <div class="panel" :class="colorHeading">
      <div class="panel-heading" :class="{'go-panel-heading': !disabled}" @click="toggleOpen">
          <h5 class="panel-title panel-primary">{{title}}
            <i class="glyphicon "
               :class="{'glyphicon-ok': done}">
            </i>
            <i class="glyphicon pull-right"
               :class="{'glyphicon-chevron-down': isOpen,'glyphicon-chevron-right': !isOpen }">
            </i>
          </h5>
      </div>
      <div class="panel-body" :class="{hide: !isOpen }" ref="panelBody">
        <slot>
          <!-- ici il y aura votre contenu -->
        </slot>
      </div>
    </div>
</template>

<script>
import {getLog} from '../config'

const log = getLog('goCollapse', 4, 1)
export default {
  name: 'go-collapse',
  components: {},
  data: function () {
    return {
      isOpen: this.open
    }
  }, // end of data section
  props: {
    title: {
      type: [String, Function]
    },
    open: {
      type: Boolean,
      default: false
    },
    done: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    open: function (newVal, oldVal) {
      log.w(`## IN goCollapse.watch open title [[${this.title}]] old: ${oldVal} new: ${newVal}`)
      this.isOpen = newVal
      if (this.isOpen) {
        this.$emit('gocollapseOpen', this.isOpen)
      }
    }
  },
  computed: {
    colorHeading: function () {
      return {
        'panel-primary': this.isOpen,
        'panel-danger': !this.isOpen && !this.done,
        'panel-success': !this.isOpen && this.done,
        disable: this.disabled
      }
    }
  }, // end of computed props section

  mounted: function () {
  }, // end of computed props section

  methods: {
    toggleOpen: function () {
      log.w(`## IN goCollapse.toggleOpen title [[${this.title}]] open: ${this.isOpen} disabled: ${this.disabled}`)
      if (!this.disabled) {
        this.isOpen = !this.isOpen
        if (this.isOpen) {
          this.$emit('gocollapseOpen', this.isOpen)
        }
      }
    }
  } // end of methods section
}
</script>


<style lang="scss">

  .hide {
    display: none;
  }
  .disable {
    cursor: not-allowed;
    pointer-events: all !important;
  }
  .go-panel-heading {
    cursor: pointer;
    &:hover {
      background-color: #2aabd2;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/ui/goCollapse.vue